var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.2857,
    height: 18.2857,
    viewBox: "0 0 18.2857 18.2857",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "monitoring"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18.2857,
    height: 18.2857,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "monitoring_2",
    d: "M2.28564 15.9998V14.476L3.80945 12.9522V15.9998H2.28564ZM5.33326 15.9998V11.4284L6.85707 9.90455V15.9998H5.33326ZM8.38088 15.9998V9.90455L9.90469 11.4474V15.9998H8.38088ZM11.4285 15.9998V11.4474L12.9523 9.9236V15.9998H11.4285ZM14.4761 15.9998V8.38074L15.9999 6.85693V15.9998H14.4761ZM2.28564 12.0569V9.90455L7.61898 4.57122L10.6666 7.61884L15.9999 2.28551V4.43789L10.6666 9.77122L7.61898 6.7236L2.28564 12.0569Z",
    fill: "#444647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.b8d215b50d59b226db365aed4470e62a.svg";
export { ForwardRef as ReactComponent };